import { Link } from "react-router-dom";

import Reveal from "../common/reveal";
import { RECENT_PAPERS } from "../../data/publications";

const RecentPapers = () => (
	<Reveal as="section" className="wrap sec">
		<div
			className="sec-head"
			style={{ marginBottom: "clamp(24px, 3.5vw, 40px)" }}
		>
			<div className="secnum">04 · Recent papers</div>
			<Link to="/publications" className="link-plain">
				All fourteen →
			</Link>
		</div>

		<div className="rule-bottom">
			{RECENT_PAPERS.map((paper, index) => (
				<a
					key={paper.id}
					href={paper.link}
					target="_blank"
					rel="noreferrer"
					className={
						"row-paper " +
						(index === 0 ? "rule-top" : "rule-top-soft")
					}
				>
					<span className="paper-date-sm">
						{paper.year} · {paper.venue}
					</span>
					<span className="paper-body paper-title">
						{paper.title}
						{paper.badgeShort && (
							<em
								className="badge-accent"
								style={{ marginLeft: "8px" }}
							>
								{paper.badgeShort}
							</em>
						)}
					</span>
				</a>
			))}
		</div>
	</Reveal>
);

export default RecentPapers;
